import React, { useState } from 'react';
import { CreateFlowModal } from './CreateFlowModal';
import { ModalContent } from './shared/FormComponents';
import { CreateFlowBackButton } from './shared/CreateFlowBackButton';
import { ManualCreateForm } from './shared/ManualCreateForm';
import useCreateCourse from 'hooks/useCreateCourse';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { Redirect } from 'react-router-dom';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

interface IProps {
  onClose: () => void;
  onBack: () => void;
}

export const ManualCreateCourseModal = (props: IProps) => {
  const { onClose, onBack } = props;
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  
  const user = useCurrentUser();
  const [createCourse, { status: creationStatus, data: responseData }] = useCreateCourse();
  const course = normalizeJSONAPIResponse(responseData?.data);

  const handleCreateCourse = async () => {
    if (!title.trim() || !user?.primaryPartner.id) return;

    try {
      const payload: any = {
        name: title,
        partner_id: user.primaryPartner.id
      };

      // Add description if provided
      if (description.trim()) {
        payload.description = description;
      }

      await createCourse(payload);
      
      // Navigation to course detail page will happen via Redirect component
    } catch (error) {
      console.error('Error creating course:', error);
      // TODO: Show error message to user
    }
  };

  const isCreating = creationStatus === 'loading';

  // Redirect to course detail page after successful creation
  if (creationStatus === 'success' && course?.id) {
    return (
      <Redirect
        to={{
          pathname: `/nav/courses/${course.id}`,
        }}
      />
    );
  }

  return (
    <CreateFlowModal title="Create Course (Manual Create)" onClose={onClose}>
      <ModalContent>
        <CreateFlowBackButton onClick={onBack} />

        <ManualCreateForm
          title={title}
          description={description}
          onTitleChange={setTitle}
          onDescriptionChange={setDescription}
          onSubmit={handleCreateCourse}
          isCreating={isCreating}
          submitButtonText="Create Course"
        />
      </ModalContent>
    </CreateFlowModal>
  );
};
